var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-container",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{class:[
    'background',
    { 'is-null': _vm.value === null, 'is-on': _vm.value === true, 'is-null-loader': _vm.showNullLoader }
  ]},[_c('div',{class:['potard', { 'right': _vm.value === true }]})])])}
var staticRenderFns = []

export { render, staticRenderFns }